<template>
    <b-form-select-option :disabled="disabled" :value="value">
        <slot />
    </b-form-select-option>
</template>

<script>
import { BFormSelectOption } from 'bootstrap-vue'

export default {
    components: { BFormSelectOption },
    props: {
        disabled: { type: Boolean, default: false },
        value: { type: null, required: true }
    }
}
</script>